// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.outer-div.tooltip-filter {
    display: inline-flex;
    align-items: center;
    flex-direction: inherit;
    justify-content: flex-start;
}
`, "",{"version":3,"sources":["webpack://./src/components/Modules/TeamAlerts/component/SearchTab/TooltipFilter/TooltipFilter.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;AAC/B","sourcesContent":[".outer-div.tooltip-filter {\n    display: inline-flex;\n    align-items: center;\n    flex-direction: inherit;\n    justify-content: flex-start;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
